import MathUtils from './math';

const ProgressUtils = {
  calculateProgressInTime(pointer: number, start: number, end?: number) {
    const progress = ((pointer - start) / ((end || start) - start)) * 100;
    return MathUtils.numberWithinRange(progress, 0, 100);
  },
};

export default ProgressUtils;
